import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { buildListQuery, ListQueryOptions, normalizePaginatedListResponse, PaginatedApiResponse } from '../../../services/paginatedList';
import { moduleConfig } from './config';

export interface CrewQuestionnaireKind {
  id: number;
  code: string;
  name: string;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const useCrewQuestionnaireKinds = (search?: string, page = 1, limit = 25, options?: ListQueryOptions) => {
  const query = buildListQuery(search, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<PaginatedApiResponse<CrewQuestionnaireKind> | CrewQuestionnaireKind[]>(
    `${moduleConfig.module.api.list}${query}`, fetcher, { revalidateOnFocus: true },
  );
  const normalized = normalizePaginatedListResponse(data, page, limit);
  return { ...normalized, clients: normalized.data, isLoading, isError: error, mutate };
};

export const useCrewQuestionnaireKind = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<CrewQuestionnaireKind>(
    id ? moduleConfig.module.api.detail(id) : null, fetcher, { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
